import { render, staticRenderFns } from "./OTNueva.vue?vue&type=template&id=49809db6&"
import script from "./OTNueva.vue?vue&type=script&lang=js&"
export * from "./OTNueva.vue?vue&type=script&lang=js&"
import style0 from "./OTNueva.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports